<template>
  <div>
    <!-- 关于汇利兴 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> / <a>关于汇利兴</a>
        </div>
        <div class="page-center-box w-100">
          <div class="page-left">
            <div class="box-info1 w-100">关于汇利兴</div>
            <div class="box-info2 w-100">
              <span
                :class="{ active: linkActive === item.type }"
                :key="item.label"
                v-for="(item, index) in linkList"
                @click="refresh(item)"
                >{{ item.label }}</span
              >
            </div>
          </div>
          <div class="page-right" style="padding-top: 0;padding-bottom: 0;">
            <div class="about-box w-100" v-if="linkActive === 'about'">
              <div class="top-box w-100">— 关于汇利兴 —</div>
              <div class="lower-box w-100">
                重庆汇利兴工业自动化设备有限公司始创于2011年，隶属广东汇兴精工智造股份有限公司（股票代码839258）始创2000年旗下西南地区全资子公司,是一家专业从事智能装备配件设计、研发、制造及营销的企业。2016年，汇利兴挂牌新三板，2017年、2018年、2019年，汇利兴连续三年进入“新三板创新层”。<br /><br />
                作为新三板创新层企业，重庆工厂是总部五大智能装备智造基地之一，并拥有东莞一厂、东莞二厂、昆山工厂、江西工厂等五大智能装备制造基地，在东莞、昆山、重庆、厦门、武汉、宁波、德国设有营销子（分）公司，在深圳、顺德、中山、青岛等地区设有办事处，为家用电器、卫浴陶瓷、新能源、LED、汽车零部件、家具厨具、物流输送、3C电子、医药食品、包装印刷等细分领域提供整厂自动化系统解决方案及精密工业自动化配件一站式服务。
                <br /><br />
                作为东莞市倍增计划试点企业，汇兴智造用智慧创造共赢，公司以专业服务客户，与世界知名企业ABB集团、美的集团、海尔集团、格力集团、海信集团、长虹、创维集团、WALTON、Arcelik（倍科）、TCL、步步高集团、海格通信、奥马电器、Duravit（杜拉维特）、九牧卫浴、箭牌卫浴、恒洁卫浴、东鹏洁具、安华卫浴、浪鲸卫浴、比亚迪、北汽集团、时代高科、ISS
                GROUP等建立战略合作关系，产品畅销全球50多个国家和地区。<br /><br />
                作为国家高新技术企业，公司以创新驱动发展，获批建立广东省院士专家企业工作站、广东省工程技术研究中心、东莞市院士工作站、东莞市工程技术研究中心、东莞市研究生联合培养（实践）工作站，建有东莞市智能装备科普教育基地，聘请物联网专家、中国工程院院士孙玉院士担任首席技术顾问，并与中科院自动化所、华南农业大学、江西理工大学、广州广联数字家庭产业技术研究院等高校院所开展紧密的产学研合作。
                <br /><br />
                作为东莞市知识产权保护重点企业，公司以知识产权提升竞争力，拥有系列自主知识产权。公司通过“企业知识产权管理体系”认证，参与6项国家标准的起草，其中2项国家标准已发布；申请专利72项，获得授权专利45项，其中，授权发明专利11项，实用新型专利33项，外观设计专利1项；获得计算机软件著作权15项、注册商标11项。
                作为国家标准化良好行为AAAA级企业，公司以品质诠释诚信，建立来料、制程、终检、仓储、出货、物流等一整套严格的品质管控流程，通过质量管理体系认证、安全生产标准化、欧盟CE、德国莱茵、SGS等多项体系及产品认证，产品品质、生产安全符合国际及国家标准。
                <br /><br />
                作为零部件新三板创新层企业，公司以创新研发为动力，依托公司累积的庞大资源，凭借优越的商业模式，清晰明了的战略部署，以智能自动化设备更智能装配为己任，致力打造“成为行业优秀的智能自动化产业链集成服务商”的企业愿景，持续永久为行业客户提供工业铝型材及装配系统，各类别智能自动化输送系列，精益生产系统、辊式输送系统、线性输送系统、成套工业控制系统、模块化输送系统、机械安全防护系统等智能自动化行业提供标准化、定制化、个性化、模块化的专用高端精密零部件。
                <br /><br />
                近几年，公司获得了多项荣誉。公司荣获“全国模范院士专家工作站”、“广东省战略性新兴产业培育企业”、“广东省高成长中小企业”、“广东省守合同重信用企业”,入选“东莞市重点企业规模与效益倍增试点企业”、“东莞市第十一批上市后备企业”，荣获“东莞市成长型中小企业”、“东莞市知识产权保护重点企业”、“东莞市十大创新企业”。
                <br />
                展望未来，公司永远跟党走，将牢记“做受尊敬的好人、造受尊敬的产品、办受尊敬的企业、建受尊敬的平台”的企业使命，践行“创于手、精于工、智于器、匠于心、品于行”的工匠精神，持续推动制造智能化、软件信息化、系统集成化的创新发展，用最具性价比的整厂自动化系统解决方案服务制造业，为中国制造的崛起增添新动能，贡献新力量。
              </div>
            </div>
            <div class="content-box w-100" v-else style="min-height: 33.75rem;justify-content: center;">
              <baidu-map
                v-if="false"
                class="top-box w-100"
                :zoom="zoom"
                :center="center"
                @ready="handler"
                :scroll-wheel-zoom="true"
                :ak="ak"
              >
                <bm-marker :position="center" name=""></bm-marker>
              </baidu-map>
              <div class="lower-box w-100" style="min-height: 33.75rem;justify-content: center;">
                <ul class="content-box" style="min-height: 33.75rem;display: flex;justify-content: center; align-items: center;">
                  <li>
                    <i><img src="../../assets/images/icon_16.png" /></i>
                    <span>地址</span>
                    <p>重庆市九龙坡区西彭镇森迪大道8号2幢</p>
                  </li>
                  <li>
                    <i><img src="../../assets/images/icon_17.png" /></i>
                    <span>电话</span>
                    <p>023-68617887 68617883</p>
                  </li>
                  <li>
                    <i><img src="../../assets/images/icon_18.png" /></i>
                    <span>传真</span>
                    <p>023-68619776</p>
                  </li>
                  <li>
                    <i><img src="../../assets/images/icon_19.png" /></i>
                    <span>联系人</span>
                    <p>13637773033（胡先生）</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
export default {
  data () {
    return {
      center: {
        lng: 0,
        lat: 0,
      },
      ak: 'O4aFVMSLVl1aiTX2sF40aVfC',
      zoom: 13,
      linkList: [
        {
          label: '公司简介',
          path: '/about',
          type: 'about'
        },
        {
          label: '联系我们',
          path: '/contact',
          type: 'contact'
        },
      ],
      linkActive: 'about'
    }
  },
  methods: {
    handler ({ BMap, map }) {
      this.center.lng = 106.329898;
      this.center.lat = 29.331856;
      this.zoom = 19;
    },
    refresh (item) {
      this.linkActive = item.type;
    }
  }
}
</script>

<style>
.page-center-box .page-left .box-info2 span {
  width: 100%;
  float: left;
  line-height: 3.75rem;
  position: relative;
  padding-left: 1.875rem;
  font-size: 0.875rem;
  color: #333;
  cursor: pointer;
}
.page-center-box .page-left .box-info2 span::after {
  content: '';
  width: 0.25rem;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #004194;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue